export default __webpack_public_path__ + "static/media/20210227_101150.993707e8.jpg";